import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport
} from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Icon } from "@cdk-uip/react-icon";
import { candidateActions } from "../../actions/candidateActions";
import Dialog from "../common/Dialog";
import { ROLES, defaultToastOptions } from "../../constants/constants";
import api from "../../api/candidate.resource";
import ManageUsers from "../Users/ManageUsers";
import { getStatusDescription } from "../../util/helpers";

export const RecruitersList = ({
  recruitersList,
  getRecruitersList,
  history
}) => {
  const [showDeleteUserWarning, setShowDeleteUserWarning] = useState(false);
  const [showEmailUserAlert, setshowEmailUserAlert] = useState(false);
  const [showManageUsers, setShowManageUsers] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [isEditUser, setIsEditUser] = useState(false);
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;

  const columns = [
    {
      dataField: "firstName",
      text: "Name",
      sort: "true",
      formatter: (cellContent, row) => {
        return `${row.firstName} ${row.lastName}`;
      }
    },
    {
      dataField: "contactNumber",
      text: "Mobile Number"
    },
    {
      dataField: "emailId",
      text: "Email Id",
      sort: "true",
      headerStyle: { width: "25%" }
    },
    {
      dataField: "role",
      text: "Role",
      sort: "true",
      headerStyle: { width: "10%" }
    },
    {
      dataField: "statusDescription",
      text: "Status",
      headerStyle: { width: "10%" },
      sort: "true"
    },
    {
      dataField: "",
      text: "Actions",
      csvExport: false,
      headerStyle: { width: "15%" },
      formatter: (cellContent, row) => {
        return (
          <Fragment>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={renderTooltip("Edit User")}
            >
              <Icon onClick={() => handleOnClickEditUser(row)}>edit</Icon>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={renderTooltip("Delete User")}
            >
              <Icon onClick={() => handleOnClickDeleteUser(row)}>delete</Icon>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={renderTooltip("Send Email")}
            >
              <Icon onClick={() => handleOnClickEmailCredentials(row)}>
                email
              </Icon>
            </OverlayTrigger>
          </Fragment>
        );
      }
    }
  ];

  const sizePerPageList = [
    {
      text: "5",
      value: 5
    },
    {
      text: "10",
      value: 10
    },
    {
      text: "20",
      value: 20
    }
  ];

  const handleOnClickManageUsers = () => setShowManageUsers(true);

  const handleOnCloseManageUser = () => {
    setShowManageUsers(false);
    setIsEditUser(false);
    setSelectedUser({});
    getRecruitersList();
  };

  const handleOnClickEditUser = userData => {
    setSelectedUser(userData);
    setIsEditUser(prevState => !prevState);
    setShowManageUsers(prevState => !prevState);
  };

  const handleOnClickDeleteUser = userData => {
    setSelectedUser(userData);
    setShowDeleteUserWarning(prevState => !prevState);
  };

  const handleOnClickEmailCredentials = userData => {
    setSelectedUser(userData);
    setshowEmailUserAlert(prevState => !prevState);
  };
  const deleteUser = async () => {
    try {
      toast.configure();
      setShowDeleteUserWarning(false);
      const userDetails = { id: selectedUser.id };
      const res = await api.deleteUser(userDetails);
      if (res) {
        if (res.errorMessage) {
          toast.warn(res.errorMessage, defaultToastOptions);
        } else {
          toast.success(`Successfully Deleted User`, defaultToastOptions);
          getRecruitersList();
        }
      }
    } catch (e) {
      toast.error(`Error while Deleting User`, defaultToastOptions);
    } finally {
      setSelectedUser({});
    }
  };
  const inviteUser = async () => {
    try {
      toast.configure();
      setshowEmailUserAlert(false);
      const res = await api.inviteUser({ id: selectedUser.id });
      if (res) {
        if (res.errorMessage) {
          toast.warn(res.errorMessage, defaultToastOptions);
        } else {
          toast.success(`Successfully Invited User`, defaultToastOptions);
        }
      }
    } catch (e) {
      toast.error(`Error while Inviting User`, defaultToastOptions);
    } finally {
      setSelectedUser({});
    }
  };

  const getUserData = () => {
    return recruitersList && recruitersList.length
      ? recruitersList.map(user => ({
          ...user,
          statusDescription: getStatusDescription(user.status)
        }))
      : [];
  };

  let renderTooltip = message => {
    return <Tooltip id={message}>{message}</Tooltip>;
  };

  useEffect(() => {
    getRecruitersList();
  }, []);

  return (
    <Fragment>
      <div className="mt-3 mr-3">
        <div style={{ textAlign: "left" }}>
          <h5> Recruiter Information</h5>
        </div>
        <ToolkitProvider
          keyField="id"
          data={getUserData()}
          columns={columns}
          search
          exportCSV={{ fileName: "Recruiters.csv" }}
        >
          {props => (
            <Fragment>
              <div className="candidates-search-bar">
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 200 }}
                  overlay={renderTooltip("Add User")}
                >
                  <Icon
                    onClick={handleOnClickManageUsers}
                    className="add-user-icon"
                  >
                    person_add
                  </Icon>
                </OverlayTrigger>
                <SearchBar {...props.searchProps} />
                <ExportCSVButton {...props.csvProps}>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 200 }}
                    overlay={renderTooltip("Download")}
                  >
                    <Icon>file_download</Icon>
                  </OverlayTrigger>
                </ExportCSVButton>
              </div>
              <BootstrapTable
                {...props.baseProps}
                striped
                condensed
                bootstrap4
                pagination={paginationFactory({
                  sizePerPage: 10,
                  sizePerPageList: sizePerPageList
                })}
                noDataIndication="No users are available."
              />
            </Fragment>
          )}
        </ToolkitProvider>
      </div>
      {showManageUsers && (
        <ManageUsers
          roleId={ROLES.RECRUITER}
          userData={selectedUser}
          isEditUser={isEditUser}
          onClose={handleOnCloseManageUser}
        />
      )}
      {showDeleteUserWarning && (
        <Dialog
          header="Delete User"
          message={`Are you sure you want to delete ${selectedUser.firstName} ${selectedUser.lastName}?`}
          closeButtonText="CLOSE"
          saveButtonText="DELETE"
          handleClose={() => {
            setShowDeleteUserWarning(false);
            setSelectedUser({});
          }}
          handleSave={() => deleteUser()}
        />
      )}
      {showEmailUserAlert && (
        <Dialog
          header="Invite User"
          message={`Would you like to Email User Credentials to ${selectedUser.firstName} ${selectedUser.lastName}?`}
          closeButtonText="CANCEL"
          saveButtonText="SEND"
          handleClose={() => {
            setshowEmailUserAlert(false);
            setSelectedUser({});
          }}
          handleSave={() => inviteUser()}
        />
      )}
    </Fragment>
  );
};
const mapStateToProps = ({ candidateDetails }) => ({
  recruitersList: candidateDetails.recruitersList || []
});
const mapDispatchToProps = {
  getRecruitersList: candidateActions.getRecruitersList
};

export default connect(mapStateToProps, mapDispatchToProps)(RecruitersList);
